<template>
  <section>
    <notifications></notifications>
    <sidebar-help
      :title="$route.meta.title"
      :items="guides"
      :loader="loader"
      :toggleSidebar="visibleSideBar"
      @closeSidebar="closeSidebar"
    />
    <base-header>
      <div class="row align-items-center pt-header">
        <div
          class="col-lg-4 col-md-6 col-sm-6 col-6 d-flex align-items-center"
          :class="{
            'col-12 ': selectedRows.length > 0,
            'col-6 ': selectedRows.length === 0
          }"
        >
          <el-tooltip content="Back" placement="bottom">
            <base-button
              type="neutral"
              class="btn-icon-only"
              @click="goToPreviousPage()"
            >
              <i class="flaticon-left-1"></i>
            </base-button>
          </el-tooltip>
          <h1 class="title-view">{{ $route.meta.title }}</h1>
        </div>
        <div
          class="col-lg-8 col-md-6 col-sm-6 col-6"
          :class="{
            'col-12 alinmov2': selectedRows.length > 0,
            'col-6 text-right': selectedRows.length === 0
          }"
        >
          <div class="box-buttons">
            <base-dropdown
              v-if="selectedRows.length > 0"
              menu-on-left
              class="nav-item mr-2"
              tag="li"
              title-tag="a"
              title-classes="btn min-button btn-outline-neutral"
              title="Actions"
            >
              <base-button slot="title" type="none" class="p-0 min-button">
                <i class="flaticon-bold-kebab"></i>
                <strong>Actions</strong>
              </base-button>

              <div
                class="dropdown-item"
                v-if="selectedRows.length > 0"
                @click="
                  bulkConvertToBooking(
                    selectedRows,
                    handleQuotesBulkConvertToBooking
                  )
                "
              >
                <i class="flaticon-right-4 text-success"></i>
                Convert to Reservation
              </div>

              <div
                class="dropdown-item"
                v-if="selectedRows.length > 0 && canUserDelete"
                @click="
                  bulkDeleteQuotes(
                    { ids: selectedRows.map(item => item.id) },
                    bulkDeleteQuotesByIds
                  )
                "
              >
                <i class="flaticon-delete text-danger"></i>Delete
              </div>
            </base-dropdown>

            <base-button
              v-if="canUserCreate"
              type="primary"
              class="min-button m-0"
              @click="goToNewQuote()"
            >
              <i class="flaticon-plus"></i> New
              <strong class="d-lg-block d-none ml-1">Quote</strong>
            </base-button>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid forms mb-5">
      <div class="main-buttons">
        <div class="row">
          <div
            class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12 align-self-center mb-0"
          >
            <b-form-group class="mb-0">
              <b-input-group size="sm" class="input-search">
                <b-input-group-prepend class="pt-1 pl-1">
                  <i class="flaticon-bold-magnifier"></i>
                </b-input-group-prepend>
                <b-form-input
                  id="filter-input"
                  v-model.trim="simpleSearch"
                  v-on:input="applySimpleSearch"
                  type="search"
                  placeholder="Search Anything..."
                  class="border-none"
                ></b-form-input>

                <b-input-group-append class="pt-1 pb-0">
                  <b-button
                    variant="neutro"
                    v-b-toggle.toggleFilters
                    class="p-0"
                  >
                    <i class="flaticon-equalizer"></i
                  ></b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </div>
          <div
            class="col-xl-8 col-lg-8 col-md-6 col-sm-12 col-12 alinmov2 align-self-center"
          >
            <div>
              <div class="mt-md-0 mt-3">
                <base-button
                  type="outline-neutral mb-md-0 mb-2"
                  class="min-button mr-2"
                  v-if="query"
                  @click="resetSearchFilter()"
                >
                  <i class="flaticon-eraser"></i>Reset Search
                </base-button>
                <base-dropdown
                  menu-on-right
                  class="nav-item"
                  tag="li"
                  title-tag="a"
                  title-classes="btn min-button btn-outline-neutral mr-2 mb-md-0 mb-2"
                  title="Actions"
                >
                  <base-button slot="title" type="none" class="p-0 min-button">
                    <i class="flaticon-rec"></i>
                    <strong>Status</strong>
                  </base-button>

                  <div
                    class="dropdown-item"
                    @click="applyFilterByStatus('EXPIRED')"
                  >
                    <i class="flaticon-wall-clock-1 text-cancelled"></i>
                    Expired
                  </div>
                  <div
                    class="dropdown-item"
                    @click="applyFilterByStatus('NEW')"
                  >
                    <i class="flaticon-add text-new"></i> New
                  </div>
                </base-dropdown>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div
            v-if="activeFilter || sortBySync"
            class="col-12 pt-0 pb-3 text-right"
          >
            <template v-if="activeFilter">
              <span><strong>Filtered by: </strong></span>
              <ul class="box-tags-filters">
                <li class="tags-filters" v-if="simpleSearch">
                  {{ simpleSearch }}
                </li>
                <li class="tags-filters" v-if="quoteStatus">
                  {{ formatQuoteStatus(quoteStatus) }}
                </li>
                <li class="d-inline-block">
                  <span @click="resetSearchFilter()" class="curp">
                    <i class="flaticon-cancel ml-2"></i>
                  </span>
                </li>
              </ul>
            </template>
            <template v-if="sortBySync">
              <span class="ml-3"><strong>Local Sorted by:</strong></span>
              <ul class="box-tags-filters">
                <li class="tags-filters">
                  {{ getSortName(sortBySync, sortDescSync) }}
                </li>
                <li class="d-inline-block">
                  <span @click="restartSortAction()" class="curp">
                    <i class="flaticon-cancel ml-2"></i>
                  </span>
                </li>
              </ul>
            </template>
          </div>
        </div>
      </div>

      <div class="box-table">
        <div class="row">
          <div
            class="col-xl-5 col-lg-7 col-md-12 col-sm-12 col-12 align-self-center order-lg-1 order-md-2 order-sm-2 order-2"
          ></div>

          <div
            class="col-xl-7 col-lg-5 col-md-12 col-sm-12 col-12 order-lg-2 order-md-1 order-sm-1 order-1 text-right mb-1"
          >
            <div
              class="col-xl-7 col-lg-12 col-md-6 ml-auto d-inline-block mb-xl-0 mb-1"
            >
              <b-form-group
                label="Sort"
                label-for="sort-by-select"
                label-cols-sm="2"
                label-align-sm="right"
                label-size="sm"
                v-slot="{ ariaDescribedby }"
                class="mb-2"
                size="sm"
              >
                <b-input-group>
                  <b-form-select
                    id="sort-by-select"
                    v-model="sortBy"
                    :options="SORT_OPTIONS"
                    @change="applySortBy"
                    :aria-describedby="ariaDescribedby"
                    class="w-70"
                    size="sm"
                  >
                    <template #first>
                      <option value="">-- None --</option>
                    </template>
                  </b-form-select>

                  <b-form-select
                    v-model="sortDesc"
                    :disabled="!sortBy"
                    @change="applySortType"
                    :aria-describedby="ariaDescribedby"
                    class="w-30"
                    size="sm"
                  >
                    <option :value="'asc'">Asc</option>
                    <option :value="'desc'">Desc</option>
                  </b-form-select>
                </b-input-group>
              </b-form-group>
            </div>

            <div class="d-inline-block mr-2 mb-2">
              <b-form-group v-slot="{ ariaDescribedbyview }" class="mb-0">
                <b-form-radio-group
                  id="btn-radios-view"
                  v-model="view"
                  :aria-describedby="ariaDescribedbyview"
                  name="radios-btn-default"
                  buttons
                  @change="changeViewCard"
                  class="mb-0"
                  button-variant="outline-neutral pc-3"
                >
                  <b-form-radio value="table"
                    ><i class="flaticon-two" title="View Table"></i
                  ></b-form-radio>
                  <b-form-radio value="card"
                    ><i class="flaticon-menu" title="View Card"></i
                  ></b-form-radio>
                </b-form-radio-group>
              </b-form-group>
            </div>

            <div class="d-inline-block mr-2 mb-2">
              <el-tooltip
                content="Manage columns"
                placement="bottom"
                class="d-inline-flex"
              >
                <base-button
                  type="outline-neutral"
                  class="btn-icon-only mb-0"
                  @click="modalManageColumn = true"
                >
                  <i class="flaticon-bold-settings mr-0"></i>
                </base-button>
              </el-tooltip>
            </div>

            <div v-if="canUserExport" class="d-inline-block mr-2">
              <el-tooltip content="Export" placement="bottom">
                <base-dropdown
                  menu-on-right
                  class="nav-item"
                  tag="div"
                  title-tag="a"
                  title-classes="btn btn-outline-neutral btn-icon-only m-0 dropnocaret"
                  title="Export"
                >
                  <base-button slot="title" type="none" class="p-0 min-button">
                    <i class="flaticon-downloading-files mr-0 mt-2"></i>
                  </base-button>

                  <div
                    class="dropdown-item"
                    @click="exportSelectedQuotes(selectedRows)"
                    v-if="selectedRows.length > 0"
                  >
                    Selected Records
                  </div>
                  <div class="dropdown-item" @click="exportAllQuotes()">
                    All Records
                  </div>
                </base-dropdown>
              </el-tooltip>
            </div>

            <div class="d-inline-block">
              <el-tooltip content="Help" placement="bottom">
                <base-button
                  type="outline-neutral"
                  class="btn-icon-only mb-0"
                  @click="openSideBar"
                >
                  <i class="flaticon-question-1 f-16 mr-0"></i>
                </base-button>
              </el-tooltip>
            </div>
          </div>
        </div>
        <pagination-block
          :pageCount="quoteResponse.pages"
          :total="quoteResponse.count"
          :limit="limit"
          v-model="currentPage"
          @changePage="changePage"
          @nextPage="nextPage"
          @prevPage="prevPage"
          @changeLimit="changeLimit"
          position="bottom"
        ></pagination-block>

        <b-table
          hover
          :items="quotes"
          :fields="fields"
          :sort-by.sync="sortBySync"
          :sort-desc.sync="sortDescSync"
          selectable
          @row-selected="onRowSelected"
          select-mode="multi"
          ref="selectableTable"
          sort-icon-left
          :filter="filterOne"
          show-empty
          empty-filtered-text="There are no records matching your request"
          empty-text="There are no records to show"
          :tbody-transition-props="transProps"
          :stacked="cardview"
          :table-class="getTableClass(quotes)"
          responsive
          sticky-header
          no-sort-reset
        >
          <template #head()="{ label, field: { key } }">
            <span v-if="key === 'selected'">
              <span
                @click="clearSelected"
                v-if="selectedRows.length == quotes.length"
                class="check-table selected"
              ></span>

              <span @click="selectAllRows" v-else class="check-table"></span>
            </span>
            <span v-else>{{ label }}</span>
          </template>
          <template #cell(selected)="{ rowSelected }">
            <template v-if="rowSelected">
              <span aria-hidden="true" class="check-table selected"></span>
            </template>
            <template v-else>
              <span aria-hidden="true" class="check-table"></span>
            </template>
          </template>

          <template #thead-top="data">
            <draggable
              tag="b-tr"
              v-model="fields"
              @change="changDraggable"
              draggable=".dragg"
              sortable="true"
              :sort="true"
            >
              <b-th
                v-for="(field, index) in fields"
                :key="index"
                class="draggable text-center"
                :class="[
                  {
                    'no-drag': !field.settings.drag,
                    dragg: field.settings.drag,
                    'b-table-sort-icon-left': field.sortable
                  }
                ]"
                style="padding: 0px 10px 10px 10px !important"
                :aria-sort="sortBySync"
                :width="field.width"
              >
                <span class="drag-drop" v-if="field.settings.drag"> </span>
              </b-th>
            </draggable>
          </template>

          <template #cell(quoteNumber)="data">
            <router-link :to="goToEditQuote(data.item.id)">
              {{ data.item.quoteNumber }}
            </router-link>

            <el-popover
              placement="bottom"
              trigger="hover"
              width="300"
              class="curp d-inline-flex ml-1"
              v-if="data.item.childSeatsCount > 0"
            >
              <div class="p-2">
                <span>
                  <strong>Notes: </strong>
                  <span class="text-min hide-data-multiple">
                    This quote includes child seat(s). <br />
                    <br />
                    Please ensure that all requests have been confirmed with the
                    supplier and correctly added as extras.</span
                  >
                </span>
              </div>

              <div slot="reference" class="d-flex text-warning">
                <i class="flaticon-circle"></i>
              </div>
            </el-popover>
          </template>

          <template #cell(transferType)="data">
            <span v-html="formatTransferType(data.item.quoteType)"></span>
          </template>

          <template #cell(classQuote)="data">
            <span class="text-capitalize">Private Transfer</span>
          </template>

          <template #cell(from)="data">
            <span class="multiline-3">{{ data.item.origin.name }} </span>
          </template>

          <template #cell(to)="data">
            <span class="multiline-3" v-if="data.item.quoteType !== 'HOURLY'">
              {{ data.item.destination.name }}
            </span>
          </template>

          <template #cell(dateAndTime)="data">
            <span>
              {{ formatQuoteDate(data.item.pickupDate) }}
            </span>
            <span class="d-block">
              {{ formatQuoteTime(data.item.pickupTime) }}
            </span>
          </template>

          <template #cell(passenger)="data">
            <div
              class="d-flex align-items-center"
              @click.stop="toggleDetails(data.item, data.item.quoteNumber)"
            >
              <span>
                <i
                  class="flaticon-web-down-chevron mr-2 f-10"
                  v-if="!isRowExpanded(data.item)"
                ></i>
                <i
                  class="flaticon-web-up-chevron mr-2 f-10"
                  v-if="isRowExpanded(data.item)"
                ></i>
              </span>

              <span class="text-capitalize">
                {{
                  getPassenger(data.item.passengers, data.item.passengersCount)
                }}
              </span>
            </div>
          </template>

          <template #cell(passengersCount)="data">
            <span>{{ data.item.passengersCount }} </span>
          </template>

          <template #cell(transportRef)="data">
            <div v-if="data.item.quoteType !== 'JOURNEY'">
              <span class="role-table">
                {{ formatLabelTransport(data.item.quoteType) }}
              </span>
              <span
                class="d-block"
                :class="{
                  uppercase: data.item.routerReference ? true : false
                }"
              >
                {{ data.item.routerReference || "Not included" }}
              </span>
            </div>

            <div v-else>
              <span>-</span>
            </div>
          </template>

          <template #cell(customer)="data">
            <ShowAgent
              v-if="data.item.agent"
              :agent="data.item.agent"
              :customerId="data.item.customer ? data.item.customer._id : null"
            />
            <ShowCustomer v-else :customer="data.item.customer" />
          </template>

          <template #row-details="data">
            <div class="table-toggle ml-4">
              <div
                class="card w-100"
                :class="{ max: data.item.passengersCount > 8 }"
              >
                <h2 class="subtitle mb-3">Pax</h2>
                <b-table
                  hover
                  :items="data.item.passengers"
                  :fields="
                    formatPassengerTableHeaders(
                      FIELDS_PASSENGER_TABLE,
                      data.item.quoteType
                    )
                  "
                  sort-by.sync="fullname"
                  sort-desc.sync="true"
                  selectable
                  @row-selected="onRowSelected"
                  select-mode="multi"
                  ref="passengertable"
                  sort-icon-left
                  responsive
                  show-empty
                  empty-filtered-text="There are no records matching your request"
                  empty-text="There are no records to show"
                >
                  <template #cell(fullname)="data">
                    <span class="text-capitalize"
                      >{{ getTitleByGender(data.item.gender) }}
                      {{ data.item.firstName }}
                      {{ data.item.lastName }}
                    </span>

                    <span
                      class="badge-status badge-default mr-2"
                      v-if="data.item.primary"
                      >Primary</span
                    >
                  </template>

                  <template #cell(phone)="data">
                    <span v-if="data.item.phone">{{ data.item.phone }}</span>
                    <span v-else>N/A</span>
                  </template>

                  <template #cell(email)="data">
                    <span class="hide-data lower" v-if="data.item.email">
                      {{ data.item.email }}
                    </span>
                    <span v-else> N/A</span>
                  </template>

                  <template #cell(itinerary)="data">
                    <span class="uppercase" v-if="data.item.flightNumber">{{
                      data.item.flightNumber
                    }}</span>
                    <span v-else>N/A</span>
                  </template>

                  <template #cell(type)="data">
                    {{ formatPassengerType(data.item.type) }}
                  </template>

                  <template #cell(notify)="data">
                    {{ data.item.notify ? "Yes" : "No" }}
                  </template>

                  <template #cell(actions)="data">
                    <el-tooltip content="Copy data" placement="bottom">
                      <span
                        class="icon-action mr-2"
                        @click.stop="copyPassengerData(data.item)"
                      >
                        <i class="flaticon-copy text-black"></i>
                      </span>
                    </el-tooltip>
                  </template>
                </b-table>
              </div>
            </div>
          </template>

          <template #cell(service)="data">
            <div v-if="data.item.service">
              <div class="box-img-card">
                <div class="img-car">
                  <LazyImage
                    :src="data.item.service.vehicle.information.image"
                    imgClasses="img-fluid es-img-service-2"
                  />
                </div>

                <div class="content">
                  <span class="capitalize hide-data title">
                    {{
                      formatServiceCategory(
                        data.item.service.vehicle.parameters.category
                      )
                    }}
                  </span>

                  <span class="hide-data subtitle-1">
                    {{ data.item.service.vehicle.parameters.name }} or Similar
                  </span>
                  <span class="hide-data subtitle-1">
                    {{
                      vehicleTypeFormat(
                        data.item.service.vehicle.parameters.type
                      )
                    }}
                  </span>
                </div>
              </div>
            </div>
          </template>

          <template #cell(supplier)="data">
            <div>
              <span class="role-table" v-if="data.item.branch">
                {{ data.item.branch.name }}
              </span>
              <a
                v-if="data.item.supplier"
                class="capitalizeb break-data"
                :href="`/suppliers/${data.item.quote.supplier._id}`"
                target="_blank"
              >
                {{ data.item.quote.supplier.businessDetails.name }}
              </a>
            </div>
          </template>

          <template #cell(referredBy)="data">
            <span v-if="data.item.referredBy">
              {{ data.item.referredBy }}
            </span>
            <span class="text-capitalize" v-else>Direct</span>
          </template>

          <template #cell(netPrice)="data">
            <span :class="data.item.netprice < 0 ? 'loss-alert' : ''">
              {{ data.item.currency.symbol }}
              {{ data.item.netPrice }}
              {{ data.item.currency.code }}</span
            >
          </template>

          <template #cell(grossPrice)="data">
            <span :class="data.item.grossprice < 0 ? 'loss-alert' : ''">
              {{ data.item.currency.symbol }}
              {{ data.item.grossPrice }}
              {{ data.item.currency.code }}</span
            >
          </template>

          <template #cell(netProfit)="data">
            <span :class="data.item.netprofit < 0 ? 'loss-alert' : ''">
              {{ data.item.currency.symbol }}
              {{ data.item.netProfit }}
              {{ data.item.currency.code }}</span
            >
          </template>

          <template #cell(totalExtras)="data">
            <span :class="data.item.totalExtras < 0 ? 'loss-alert' : ''">
              {{ data.item.currency.symbol }}
              {{ data.item.totalExtras }}
              {{ data.item.currency.code }}</span
            >
          </template>

          <template #cell(totalDiscounts)="data">
            <span :class="data.item.totalDiscounts < 0 ? 'loss-alert' : ''">
              {{ data.item.currency.symbol }}
              {{ data.item.totalDiscounts }}
              {{ data.item.currency.code }}</span
            >
          </template>

          <template #cell(totalCharge)="data">
            <span :class="data.item.totalcharge < 0 ? 'loss-alert' : ''">
              {{ data.item.currency.symbol }}
              {{ data.item.totalCharge }}
              {{ data.item.currency.code }}</span
            >
          </template>

          <template #cell(commissions)="data">
            <span
              :class="
                data.item.commissions.platform.amount < 0 ? 'loss-alert' : ''
              "
            >
              {{ data.item.currency.symbol }}
              {{ data.item.commissions.platform.amount }}
              {{ data.item.currency.code }}</span
            >
          </template>

          <template #cell(dealNumber)="data">
            <span v-if="data.item.dealNumber">{{ data.item.dealNumber }} </span>
            <span v-else>-</span>
          </template>

          <template #cell(sourceChannel)="data">
            <span class="text-capitalize hide-data">
              {{ data.item.source.origin }}</span
            >
          </template>

          <template #cell(sourceProvider)="data">
            <span class="text-capitalize hide-data">
              {{ formatSourceProvider(data.item.source) }}</span
            >
          </template>

          <template #cell(status)="data">
            <span
              class="badge-status"
              :class="getStatusClass(data.item.status)"
            >
              {{ formatQuoteStatus(data.item.status) }}
            </span>
          </template>

          <template #cell(actions)="data">
            <div class="action-column">
              <div class="button-action mr-2">
                <el-tooltip
                  content="History"
                  placement="bottom"
                  class="d-inline-flex"
                >
                  <span
                    class="icon-action text-blue"
                    @click.stop="
                      openQuoteHistory(data.item.id, data.item.quoteNumber)
                    "
                  >
                    <i class="flaticon-wall-clock-1"> </i>
                  </span>
                </el-tooltip>
              </div>
              <div class="drop-action d-inline-block">
                <base-dropdown
                  menu-on-right
                  class="nav-item"
                  tag="li"
                  title-tag="a"
                  title-classes="dropnocaret"
                  title="Actions"
                  :direction="getDirection(quotes, data.index)"
                >
                  <span slot="title"> <i class="flaticon-bold-kebab"></i></span>
                  <div
                    v-if="
                      canUserChangeStatus && canConvertQuote(data.item.status)
                    "
                    class="dropdown-item"
                    @click="
                      convertToBooking(data.item.id, convertQuoteToBookingById)
                    "
                  >
                    <span class="icon-action">
                      <i class="flaticon-right-4 text-confirmed"> </i>
                      Convert to Reservation
                    </span>
                  </div>
                  <div
                    class="dropdown-item"
                    v-if="canDownloadQuotePDF(data.item.status)"
                    @click="
                      downloadQuotePDF(
                        data.item.id,
                        data.item.quoteNumber,
                        downloadQuoteById
                      )
                    "
                  >
                    <span class="icon-action">
                      <i class="flaticon-web-bill-2"></i>Download Quote
                    </span>
                  </div>
                  <div
                    class="dropdown-item"
                    v-if="canUserCreate && canDuplicateQuote(data.item.status)"
                    @click="duplicateQuote(data.item.id, duplicateQuoteById)"
                  >
                    <span class="icon-action">
                      <i class="flaticon-copy"></i>Duplicate
                    </span>
                  </div>

                  <div
                    class="dropdown-item"
                    v-if="
                      canUserChangeStatus && canCancelQuote(data.item.status)
                    "
                    @click="cancelQuote(data.item.id, cancelQuoteById)"
                  >
                    <span class="icon-action">
                      <i class="flaticon-remove text-cancelled"></i> Cancel
                    </span>
                  </div>
                  <div class="dropdown-divider"></div>
                  <div
                    class="dropdown-item"
                    v-if="canUserDelete"
                    @click="deleteQuote(data.item.id, deleteQuoteById)"
                  >
                    <span class="icon-action">
                      <i class="flaticon-delete text-danger"></i>Delete
                    </span>
                  </div>
                </base-dropdown>
              </div>
            </div>
          </template>
        </b-table>
        <pagination-block
          :pageCount="quoteResponse.pages"
          :total="quoteResponse.count"
          v-model="currentPage"
          :limit="limit"
          @changePage="changePage"
          @nextPage="nextPage"
          @prevPage="prevPage"
          @changeLimit="changeLimit"
          position="bottom"
        ></pagination-block>
      </div>
    </div>

    <ManageTableColumns
      :value="modalManageColumn"
      :fields="fields"
      :tableGridConfig="QUOTE_TABLE_DEFAULTS"
      :mandatories="['quoteNumber']"
      @saveColumns="saveColumnsInUserAccount"
      @closeTableGridModal="closeTableGridModal"
    />

    <QuoteHistory
      :show="showQuoteHistory"
      :tempQuoteId="tempQuoteId"
      :quoteNumber="tempQuoteNumber"
      @close="closeQuoteHistoryModal"
    />
  </section>
</template>

<script>
import draggable from "vuedraggable";
import { mapGetters, mapActions, mapMutations } from "vuex";
import {
  QuotesAPI,
  SettingsAPI,
  DocumentsAPI,
  ExportAPI
} from "../../../core/api";
import { DropdownPlugin, TablePlugin } from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { DropdownMenu, DropdownItem, Dropdown, MessageBox } from "element-ui";
import Pusher from "pusher-js";
import WSelect from "@/components/Select";
import ShowCustomer from "../../../components/clients/ShowCustomer.vue";
import ShowAgent from "../../../components/clients/ShowAgent.vue";
import ManageTableColumns from "@/components/ManageTableColumns";
import lodash from "lodash";
import QuoteHistory from "../components/QuoteHistory.vue";
import {
  goBack,
  isUserAuthorized,
  ROLE_HIERARCHY,
  setSigOut
} from "../../../helpers/commons.helpers";
import {
  QUOTE_TABLE_DEFAULTS,
  FIELDS_PASSENGER_TABLE
} from "../../../core/constants";
import {
  bulkDeleteQuotes,
  deleteQuote,
  cancelQuote,
  duplicateQuote,
  downloadQuotePDF,
  convertToBooking,
  bulkConvertToBooking,
  exportQuotes
} from "../services/alerts.service";
import {
  formatLabelTransport,
  formatPassengerTableHeaders,
  formatPassengerType,
  formatQuoteDate,
  formatQuoteStatus,
  formatQuoteTime,
  formatServiceCategory,
  formatSourceProvider,
  formatTransferType,
  roundToTwoDecimals,
  vehicleTypeFormat
} from "../services/format.service";
import {
  getStatusClass,
  canCancelQuote,
  canConvertQuote,
  canDownloadQuotePDF,
  canDuplicateQuote
} from "../services/status.service";
import { SORT_OPTIONS } from "../constants/commons.constants";

WSelect.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};

export default {
  name: "Quotes",
  components: {
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [MessageBox.name]: MessageBox,
    DropdownPlugin,
    TablePlugin,
    WSelect: WSelect,
    flatPickr,
    draggable,
    ShowCustomer: ShowCustomer,
    ShowAgent: ShowAgent,
    ManageTableColumns: ManageTableColumns,
    QuoteHistory
  },
  data() {
    return {
      limit: 0,
      currentPage: 1,
      selectedRows: [],
      pusher: null,
      channelSubscription: null,
      filterOne: null,
      simpleSearch: "",
      activeFilter: false,
      transProps: {
        name: "flip-list"
      },
      quoteStatus: "",
      query: "",
      sortBy: "",
      sortDesc: "desc",
      SORT_OPTIONS,
      timeoutId: null,
      cardview: false,
      view: "table",
      modalManageColumn: false,
      fields: [],
      visibleSideBar: false,
      showQuoteHistory: false,
      tempQuoteId: "",
      tempQuoteNumber: "",
      guides: [],
      loader: false,
      sortBySync: "",
      sortDescSync: false,
      expandedRow: null,
      FIELDS_PASSENGER_TABLE,
      QUOTE_TABLE_DEFAULTS
    };
  },
  watch: {
    sortDescSync: {
      handler: async function(current, old) {
        await this.changeSortDescSync(current);
      },
      deep: true
    },
    sortBySync: {
      handler: async function(current, old) {
        await this.changeSortByAsync(current);
      },
      deep: true
    },
    query: {
      handler: async function(current, old) {
        await this.changeQuery(current);
      },
      deep: true
    }
  },
  async created() {
    Pusher.logToConsole = process.env.VUE_APP_ENV === "development";
    this.pusher = new Pusher(process.env.VUE_APP_PUSHER_API_KEY, {
      cluster: process.env.VUE_APP_PUSHER_CLUSTER
    });
    this.fields = this.populateFiles(this.settings);
    this.sortBySync = this.getSortBySync(this.settings);
    this.sortDescSync = this.getSortDescSync(this.settings);
    this.query = this.getQuery(this.settings);
    this.getSesion();
    var bread = [
      {
        text: "Dashboard",
        to: "/dashboard"
      },

      {
        text: "Quotes",
        active: true
      }
    ];
    this.setItemsBread(bread);
    await this.getLimit();
    await this.initFilters(this.query);
    this.limit = this.paginationLimit;
    this.currentPage = this.tempPagination.status
      ? this.tempPagination.currentPage
      : 1;
    this.get(true, this.limit, this.currentPage, this.query);
    // Subscribe to the quotes channel
    this.channelSubscription = this.pusher.subscribe(`rhomtrip-quotes`);
    this.listenToQuoteChannel(this.channelSubscription);
  },
  methods: {
    cancelQuote,
    bulkDeleteQuotes,
    duplicateQuote,
    deleteQuote,
    formatQuoteDate,
    formatQuoteTime,
    formatTransferType,
    vehicleTypeFormat,
    formatServiceCategory,
    formatPassengerType,
    formatSourceProvider,
    formatQuoteStatus,
    downloadQuotePDF,
    convertToBooking,
    getStatusClass,
    formatPassengerTableHeaders,
    canCancelQuote,
    canConvertQuote,
    canDownloadQuotePDF,
    canDuplicateQuote,
    bulkConvertToBooking,
    formatLabelTransport,
    exportQuotes,
    addElementInQuery(query, key, value) {
      let searchParams = new URLSearchParams(query);
      if (searchParams.has(key)) {
        searchParams.set(key, value ? value.trim() : value);
      } else {
        searchParams.append(key, value ? value.trim() : value);
      }
      return searchParams.toString();
    },
    deleteItemInQuery(query, keys = []) {
      let searchParams = new URLSearchParams(query);
      keys.forEach(key => {
        if (searchParams.has(key)) {
          searchParams.delete(key);
        }
      });
      return searchParams.toString();
    },
    async applyFilterByStatus(status) {
      this.activeFilter = true;
      this.quoteStatus = status;
      this.query = this.addElementInQuery(this.query, "status", status);
      await this.get(true, this.limit, this.currentPage, this.query);
    },
    async initFilters(query) {
      if (query) {
        let searchParams = new URLSearchParams(query);
        this.sortBy = searchParams.has("sortBy")
          ? searchParams.get("sortBy")
          : "";
        this.sortType = searchParams.has("sortType")
          ? searchParams.get("sortType")
          : "";
        this.sortBySync = this.sortBy;
        this.sortDescSync = this.sortType === "desc" ? true : false;

        this.simpleSearch = searchParams.has("search")
          ? searchParams.get("search")
          : "";
        this.quoteStatus = searchParams.has("status")
          ? searchParams.get("status")
          : "";
      }
    },
    async resetSearchFilter() {
      this.currentPage = 1;
      this.simpleSearch = "";
      this.quoteStatus = "";
      this.query = "";
      this.activeFilter = this.query ? true : false;
      await this.get(true, this.limit, this.currentPage, this.query);
    },
    listenToQuoteChannel(channel) {
      channel.bind("quotes", async data => {
        const { requester, action, quote } = data;
        const isAllowedRole = ROLE_HIERARCHY.includes(this.sesion.role);
        const isRequesterDifferent = requester.id !== this.sesion.id;
        if (isAllowedRole && isRequesterDifferent) {
          await this.get(false, this.limit, this.currentPage, this.query);
          this.notifyQuoteAction(action, quote);
        }
      });
    },
    changeLimit(limit) {
      if (this.limit !== limit) {
        this.limit = limit;
        this.currentPage = 1;
        this.get(true, this.limit, this.currentPage, this.query);
      }
    },
    prevPage(page) {
      this.get(true, this.limit, page, this.query);
    },
    nextPage(page) {
      this.get(true, this.limit, page, this.query);
    },
    changePage(page) {
      this.get(true, this.limit, page, this.query);
    },
    handleError(error, message, title = "Error!") {
      if (error.response) {
        let { data } = error.response;
        if (data.code === 401) {
          let auth = setSigOut(error);
          if (auth) {
            this.setSigOut(true);
          }
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } else {
        this.$notify({
          type: "danger",
          title: title,
          message: message,
          icon: "flaticon-remove"
        });
      }
    },
    getCustomerName(customer) {
      if (customer) {
        if (["business", "travel_agency"].includes(customer.type)) {
          return customer.company_name
            ? customer.company_name
            : `${customer.first_name} ${customer.last_name}`;
        } else {
          return `${customer.first_name} ${customer.last_name}`;
        }
      }
      return "unknown";
    },
    get(loader, limit, page, query) {
      this.getQuotes({
        loader: loader,
        limit: limit,
        page: page,
        query: query
      });
    },
    notifyQuoteAction(action, quote) {
      if (action === "deleted") {
        this.$notify({
          type: "success",
          title: "Deleted!",
          message: quote
            ? `The quote "${quote.quoteNumber}" has been Deleted`
            : "The quote has been Deleted",
          icon: "flaticon-check-3"
        });
      } else if (action === "canceled") {
        this.$notify({
          type: "success",
          title: "Cancelled!",
          message: quote
            ? `The quote "${quote.quoteNumber}" has been cancelled`
            : "The quote has been cancelled",
          icon: "flaticon-check-3"
        });
      } else if (action === "created") {
        this.$notify({
          type: "success",
          title: "Success!",
          message: quote
            ? `The quote "${quote.quoteNumber}" has been created`
            : "The quote has been created",
          icon: "flaticon-check-3"
        });
      } else if (action === "converted") {
        this.$notify({
          type: "success",
          title: "Converted!",
          message: quote
            ? `The quote "${quote.quoteNumber}" has been converted`
            : "The quote has been converted",
          icon: "flaticon-check-3"
        });
      }
    },
    onRowSelected(selectedRows) {
      this.selectedRows = selectedRows;
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows();
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected();
    },
    async applySimpleSearch(value) {
      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(async () => {
        this.activeFilter = true;
        if (value) {
          this.query = this.addElementInQuery(this.query, "search", value);
          await this.get(true, this.limit, this.currentPage, this.query);
        } else {
          this.query = this.deleteItemInQuery(this.query, ["search"]);
          await this.get(true, this.limit, this.currentPage, this.query);
        }
      }, 500);
    },
    changeViewCard() {
      if (this.view === "table") {
        this.cardview = false;
      } else {
        this.cardview = true;
      }
    },
    async applySortBy(value) {
      if (value) {
        this.query = this.addElementInQuery(this.query, "sortBy", value);
        this.query = this.addElementInQuery(
          this.query,
          "sortType",
          this.sortDesc
        );
      } else {
        this.sortDesc = "desc";
        this.query = this.deleteItemInQuery(this.query, ["sortBy", "sortType"]);
      }
      this.sortBySync = value;
      this.sortDescSync = this.sortDesc === "desc" ? false : true;
      await this.get(true, this.limit, this.currentPage, this.query);
    },
    async applySortType(value) {
      this.query = this.addElementInQuery(this.query, "sortType", value);
      this.sortDescSync = value === "desc" ? false : true;
      await this.get(true, this.limit, this.currentPage, this.query);
    },
    getDirection: function(reservations = [], index) {
      if (reservations.length >= 5) {
        let position = reservations.length - index;
        if (position === 5) {
          return "down";
        } else {
          return position > 5 ? "down" : "up";
        }
      }
      return "down";
    },
    getTableClass(reservations = []) {
      return reservations.length < 7
        ? "b-table-separator main-table"
        : "main-table";
    },
    goToNewQuote() {
      this.$router.push("/quotes/new");
    },
    async changDraggable(column) {
      let { status, settings } = await this.updateSettingLayoutsByUserId(
        this.sesion.id,
        { "settings.quotes.tableLayouts": this.fields }
      );
      if (status) {
        this.setSettings(settings);
      }
    },
    closeTableGridModal(status) {
      this.modalManageColumn = status;
    },
    async saveColumnsInUserAccount(fields = []) {
      this.modalManageColumn = false;
      this.fields = fields;
      let { status, settings } = await this.updateSettingLayoutsByUserId(
        this.sesion.id,
        { "settings.quotes.tableLayouts": this.fields }
      );
      if (status) {
        this.$notify({
          type: "success",
          title: "Success!",
          message: "Columns have been changed",
          icon: "flaticon-check-3"
        });
        this.setSettings(settings);
      } else {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "Columns haven't been changed. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    async updateSettingLayoutsByUserId(userId, payload) {
      try {
        let { data } = await SettingsAPI.updateSettingLayoutsByUserId(
          userId,
          payload,
          this.sesion.token
        );
        if (data.status) {
          return { status: true, settings: data.data.settings };
        } else {
          return { status: false, settings: null };
        }
      } catch (error) {
        return { status: false, settings: null };
      }
    },
    populateFiles(settings) {
      try {
        if (settings) {
          if (settings.quotes.tableLayouts.length > 0) {
            return settings.quotes.tableLayouts;
          }
        }
        return QUOTE_TABLE_DEFAULTS.filter(option => {
          return option.settings.default;
        });
      } catch (error) {
        return QUOTE_TABLE_DEFAULTS.filter(option => {
          return option.settings.default;
        });
      }
    },
    openQuoteHistory(reservationId, quoteNumber) {
      this.tempQuoteId = reservationId;
      this.tempQuoteNumber = quoteNumber;
      this.showQuoteHistory = true;
    },
    closeQuoteHistoryModal() {
      this.showQuoteHistory = false;
    },
    closeSidebar(status) {
      this.visibleSideBar = status;
    },
    async openSideBar() {
      this.visibleSideBar = true;
      this.loader = true;
      this.guides = await this.getSupportDocuments("INTERNAL", "QUOTES");
      this.loader = false;
    },
    async getSupportDocuments(app, module) {
      try {
        let { data } = await DocumentsAPI.getSupportDocuments(
          app,
          module,
          this.sesion.token
        );
        if (data.status) {
          return data.data;
        }
        return [];
      } catch (error) {
        return [];
      }
    },
    getPassenger(passengers = [], passengersCount) {
      if (!lodash.isEmpty(passengers)) {
        let [passenger] =
          passengers.filter(passenger => passenger.primary) || passengers;
        if (passenger) {
          return `${passenger.fullName} ${
            passengersCount === 1 ? "" : `+ ${passengersCount - 1}`
          }`;
        }
      }
      return "Unassigned";
    },
    getSortBySync(settings) {
      if (settings.quotes) {
        if (settings.quotes.sortBySync) {
          return settings.quotes.sortBySync;
        }
      }
      return "";
    },
    getQuery(settings) {
      if (settings.quotes) {
        if (settings.quotes.query) {
          return settings.quotes.query;
        }
      }
      return "";
    },
    async changeSortByAsync(sortBySync) {
      let { status, settings } = await this.updateSettingLayoutsByUserId(
        this.sesion.id,
        { "settings.quotes.sortBySync": sortBySync }
      );
      if (status) {
        this.setSettings(settings);
      }
    },
    async changeQuery(query) {
      let { status, settings } = await this.updateSettingLayoutsByUserId(
        this.sesion.id,
        { "settings.quotes.query": query }
      );
      if (status) {
        this.setSettings(settings);
      }
    },
    getSortDescSync(settings) {
      try {
        if (settings.quotes) {
          if (settings.quotes.sortBySync) {
            return settings.quotes.sortDescSync;
          }
        }
        return false;
      } catch (error) {
        return false;
      }
    },
    async changeSortDescSync(sortDescSync) {
      let { status, settings } = await this.updateSettingLayoutsByUserId(
        this.sesion.id,
        { "settings.quotes.sortDescSync": sortDescSync }
      );
      if (status) {
        this.setSettings(settings);
      }
    },
    restartSortAction() {
      this.sortBySync = "";
      this.sortDescSync = false;
      this.sortBy = "";
      this.sortDesc = "desc";
      this.query = this.deleteItemInQuery(this.query, ["sortBy", "sortType"]);
      this.activeFilter = this.query ? true : false;
      this.get(true, this.limit, this.currentPage, this.query);
    },
    getSortName(sortBy, sortDesc) {
      let sort = SORT_OPTIONS.find(option => option.value === sortBy);
      if (sort) {
        return `${sort.text} - ${sortDesc ? "Descending" : "Ascending"}`;
      } else {
        return "None";
      }
    },
    getCurrency(service) {
      return {
        code: service ? service.currency_code : "",
        symbol: service ? service.currency_symbol : ""
      };
    },
    getSupplierName(supplier) {
      if (supplier && supplier.businessDetails) {
        return supplier.businessDetails.name;
      }
      return "";
    },
    goToEditQuote(quoteId) {
      return `/quotes/${quoteId}`;
    },
    getTitleByGender(gender) {
      if (gender === "male") {
        return "Mr.";
      } else if (gender === "female") {
        return "Mrs.";
      } else {
        return "Mx.";
      }
    },
    toggleDetails(item, id) {
      if (item["_showDetails"]) item["_showDetails"] = false;
      else this.$set(item, "_showDetails", true);
      this.expandedRow =
        this.expandedRow === item.booking_number ? null : item.booking_number;
    },
    isRowExpanded(item) {
      return item._showDetails && this.expandedRow === item.booking_number;
    },
    async copyPassengerData(passenger) {
      try {
        let text = `Name: ${passenger.fullName}\nPhone: ${passenger.phone}\nEmail: ${passenger.email}\n`;
        let clipboard = await navigator.clipboard.writeText(text);
        this.$notify({
          type: "success",
          title: "Success!",
          message: "The data has been copied to the clipboard",
          icon: "flaticon-check-3"
        });
      } catch (error) {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The Operation could not be completed. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    goToPreviousPage() {
      goBack(this);
    },
    /**
     *
     * Quote Action Methods
     */
    async cancelQuoteById(quoteId, reason = "") {
      try {
        this.setLoad(true);
        let { data } = await QuotesAPI.cancelQuoteById(
          quoteId,
          this.sesion.token
        );
        this.setLoad(false);
        if (!data) {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Quote can't be Cancelled",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(error, "The Quote can't be cancelled");
      }
    },
    async convertQuoteToBookingById(quoteId) {
      try {
        this.setLoad(true);
        let { data } = await QuotesAPI.createBookingFromQuoteById(
          quoteId,
          this.sesion.token
        );
        this.setLoad(false);
        if (data) {
          const { _id: bookingId } = data;
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Quote has been converted to a Booking",
            icon: "flaticon-check-3"
          });
          this.$router.push(`/reservations/${bookingId}`);
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Quote cannot be converted to a Booking",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(error, "The Quote cannot be converted to a Booking");
      }
    },
    async duplicateQuoteById(quoteId, populate) {
      if (!populate) {
        return;
      }
      this.$router.push(`/quotes/new?sourceQuoteId=${quoteId}`);
    },
    async downloadQuoteById(quoteId, quoteNumber) {
      try {
        this.setLoad(true);
        let { data } = await QuotesAPI.downloadQuotePDFById(
          quoteId,
          this.sesion.token
        );
        this.setLoad(false);
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Quote(${quoteNumber}).pdf`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation could not be completed. Please try again"
        );
      }
    },
    async deleteQuoteById(quoteId) {
      try {
        this.setLoad(true);
        let { data } = await QuotesAPI.deleteQuoteById(
          quoteId,
          this.sesion.token
        );
        this.setLoad(false);
        if (!data) {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Quote cannot be deleted!",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation could not be completed. Please try again"
        );
      }
    },
    async bulkDeleteQuotesByIds(payload = {}) {
      try {
        this.setLoad(true);
        let { data } = await QuotesAPI.bulkDeleteQuotes(
          payload,
          this.sesion.token
        );
        this.setLoad(false);
        if (!data) {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Reservations cannot be Deleted!",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation could not be completed. Please try again"
        );
      }
    },
    async handleQuotesBulkConvertToBooking(quotes = []) {
      if (quotes.some(quote => quote.status === "EXPIRED")) {
        this.$notify({
          type: "warning",
          title: "Warning!",
          message:
            "Some Quotes are expired and cannot be converted. Please review the status of the Quotes",
          icon: "flaticon-warning"
        });
        return;
      }

      if (quotes.some(quote => quote.status === "CANCELLED")) {
        this.$notify({
          type: "warning",
          title: "Warning!",
          message:
            "Some Quotes are cancelled and cannot be converted. Please review the status of the Quotes",
          icon: "flaticon-warning"
        });
        return;
      }

      if (quotes.some(quote => quote.status === "DRAFT")) {
        this.$notify({
          type: "warning",
          title: "Warning!",
          message:
            "Some Quotes are in draft status and cannot be converted. Please review the status of the Quotes",
          icon: "flaticon-warning"
        });
        return;
      }

      await this.bulkConvertToBookingByIds({
        ids: quotes.map(quote => quote.id)
      });
    },
    async bulkConvertToBookingByIds(payload = {}) {
      try {
        this.setLoad(true);
        let { data } = await QuotesAPI.createBookingsFromQuotesBulk(
          payload,
          this.sesion.token
        );
        this.setLoad(false);
        if (data) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Quotes have been converted to Bookings",
            icon: "flaticon-check-3"
          });
          this.$router.push(`/reservations`);
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Quotes cannot be converted to Bookings",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation could not be completed. Please try again"
        );
      }
    },
    exportSelectedQuotes(quotes = []) {
      const ids = quotes.map(quote => quote.id);
      this.exportQuotes({ ids: ids }, this.exportCsvFile);
    },
    exportAllQuotes() {
      let filters = {};
      if (this.quoteStatus && this.activeFilter) {
        filters.status = this.quoteStatus;
      }

      if (this.simpleSearch && this.activeFilter) {
        filters.search = this.simpleSearch;
      }

      this.exportQuotes({ ids: [], filters: filters }, this.exportCsvFile);
    },
    async exportCsvFile(payload = {}) {
      try {
        this.setLoad(true);
        let { data } = await QuotesAPI.exportQuotes(payload, this.sesion.token);
        this.setLoad(false);
        if (data) {
          const url = window.URL.createObjectURL(new Blob([data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `quotes.csv`);
          document.body.appendChild(link);
          link.click();
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The data wasn't download. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The data wasn't download. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    ...mapActions(["getSesion", "getQuotes", "getLimit"]),
    ...mapMutations([
      "setLoad",
      "setSigOut",
      "setItemsBread",
      "setTempPagination",
      "setSettings"
    ])
  },
  destroyed() {
    if (this.pusher !== null) {
      this.channelSubscription.unbind(`quotes`);
      this.pusher.disconnect();
    }
    clearTimeout(this.timeoutId);
  },
  computed: {
    quotes() {
      try {
        let quotes = this.quoteResponse.docs || [];
        return quotes.map(quote => {
          return {
            id: quote._id,
            quoteNumber: quote.quoteNumber,
            clientName: this.getCustomerName(
              quote.agent ? quote.agent : quote.customer
            ),
            agent: quote.agent,
            customer: quote.customer,
            passengers: quote.passengers,
            dealNumber: quote.dealNumber,
            status: quote.status,
            pickupDate: quote.pickupDate,
            pickupTime: quote.pickupTime,
            supplier: this.getSupplierName(quote.supplier),
            totalCharge: roundToTwoDecimals(quote.pricing.totals.gross_price),
            netPrice: roundToTwoDecimals(quote.pricing.totals.net_price),
            grossPrice: roundToTwoDecimals(quote.pricing.totals.gross_price),
            netProfit: roundToTwoDecimals(quote.pricing.totals.net_profit),
            totalExtras: roundToTwoDecimals(
              quote.pricing.totals.extras.gross_price
            ),
            totalDiscounts: roundToTwoDecimals(quote.pricing.totals.discounts),
            currency: this.getCurrency(quote.service),
            destination: quote.destination,
            origin: quote.origin,
            quoteType: quote.type,
            passengersCount: quote.passengersCount,
            childSeatsCount: quote.childSeatsCount,
            routerReference: quote.routerReference,
            commissions: quote.commissions,
            referredBy: quote.referredBy,
            dealNumber: quote.dealNumber,
            branch: quote.branch,
            service: quote.service,
            source: quote.source,
            createdAt: quote.createdAt,
            quote: quote
          };
        });
      } catch (error) {
        return [];
      }
    },
    ...mapGetters([
      "quoteResponse",
      "sesion",
      "userRole",
      "paginationLimit",
      "tempPagination",
      "settings"
    ]),
    canUserCreate() {
      return isUserAuthorized("QUOTES", this.userRole, "CREATE");
    },
    canUserDelete() {
      return isUserAuthorized("QUOTES", this.userRole, "DELETE");
    },
    canUserChangeStatus() {
      return isUserAuthorized("QUOTES", this.userRole, "CHANGE_STATUS");
    },
    canUserExport() {
      return isUserAuthorized("QUOTES", this.userRole, "EXPORT");
    }
  },
  beforeRouteLeave(to, from, next) {
    this.setTempPagination({
      currentPage: this.currentPage,
      query: this.query,
      limit: this.paginationLimit,
      status: true
    });
    next();
  }
};
</script>
